import styled from '@emotion/styled';
import FormField from 'components/FormField';
import HintInput from 'components/HintInput';
import { useTranslate } from '@tolgee/react';
import { Validate } from './share';
import { DisabledProps } from '../TaskForm/share';
import { useFormikContext } from 'formik';
import { FV } from '../NewPolicy/share';

const NameInput = styled(HintInput)`
  width: 340px;
`;

const nameLimitLength = 50;

type NameValidate = (...params: [...Parameters<Validate>, string[]]) => void;

export const validate: NameValidate = (errors, values, t, existNameList) => {
  const { name } = values;

  if (!name) {
    // eslint-disable-next-line no-param-reassign
    errors.name = t('marketing.请输入策略名称');
  } else if (name.length > nameLimitLength) {
    // eslint-disable-next-line no-param-reassign
    errors.name = t('marketing.策略名称不得超过x字', { x: nameLimitLength });
  } else if (existNameList.some((existName) => existName === name)) {
    // eslint-disable-next-line no-param-reassign
    errors.name = t('marketing.策略名称已存在');
  }
};

function NameField({ disabled }: DisabledProps) {
  const { t } = useTranslate();

  const {
    values: { knowledgeId },
  } = useFormikContext<FV>();

  return (
    <FormField<FV['name']> required name="name" label={t('marketing.策略名称')}>
      {({ field }) => {
        return (
          <NameInput
            allowClear
            disabled={disabled || Boolean(knowledgeId)}
            limit={nameLimitLength}
            maxLength={nameLimitLength}
            placeholder={t('marketing.请输入策略名称')}
            {...field}
          />
        );
      }}
    </FormField>
  );
}

export default NameField;
